import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { grey4 } from 'approot/shared/styles/colours.style';
import { ImageStaticWrapper } from 'approot/shared/images/images.style';

export const ImageUploadWrapper = styled.div`
  border: 1px solid ${grey4};
  border-radius: ${rem(borderRadius8)};
  height: ${rem(153)};

  ${ImageStaticWrapper} {
    height: ${rem(151)};
    display: flex;
    justify-content: center;
  }

  img {
    height: ${rem(151)};
    width: auto;
  }
`;
